import { useQueryClient } from 'react-query'

// TODO: layer violation — presentation layer must not reach data-access/repositories; move this into a Model
// eslint-disable-next-line @procurify/frontend-architecture-rules/layer-no-data-access-import
import { financialAccountKeys } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository/queryKey.factory'
import { useScaVerificationBase } from '../../hooks/useScaVerificationBase'
import { useQueryScaToken } from '../../models/useQueryScaToken'

export const useLongTermScaVerificationPresenter = ({
  onError,
  phoneNumber = '',
  verifyOnMount = false,
  enabled = true,
}: {
  onError: (error: Error) => void
  phoneNumber?: string
  verifyOnMount?: boolean
  enabled?: boolean
}) => {
  const queryClient = useQueryClient()

  const { isLoading, initResult, openScaVerificationModal } =
    useScaVerificationBase({
      onError,
      onVerified: (token) => {
        queryClient.setQueryData([...financialAccountKeys.getScaToken], token)
      },
      phoneNumber,
      enabled,
    })

  const { scaToken, isFetchingScaToken } = useQueryScaToken({
    initResult,
    verifyOnMount,
    openScaVerificationModal,
  })

  return {
    data: { scaToken },
    commands: {
      verifyIdentity: () => openScaVerificationModal(),
    },
    states: {
      isLoading: isLoading || isFetchingScaToken,
    },
  }
}
